import * as React from "react";
import classnames from "classnames";
import { useDrawer } from "@grandvisionhq/common";
import { spacingHelper, Text } from "@grandvisionhq/iris-ui";
/* empty css                           */
const ShowAllVariantsButton = ({ totalCount, label, className }) => {
  const { toggle } = useDrawer();
  const handleClick = (event) => {
    event.preventDefault();
    toggle();
  };
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      "data-t": "show-all-variants-button",
      className: classnames("show-all-variants-button", spacingHelper(["mt-4"]), className),
      onClick: handleClick,
      "aria-label": `${label} ${totalCount}`
    },
    /* @__PURE__ */ React.createElement(
      Text,
      {
        component: "span",
        variant: "text-caption-head",
        underline: true,
        className: "show-all-variants-button__text"
      },
      label,
      " (",
      totalCount,
      ")"
    )
  );
};
export {
  ShowAllVariantsButton
};
//# sourceMappingURL=ShowAllVariantsButton.js.map
